module.exports = __webpack_public_path__ + "static/media/lock.f6f3f421.svg";